export function formatCurrencyValue(value: number): string {
  return value.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
}

/** USD string for grid cells; null/undefined treated as $0.00 (prior manual formatter behavior). */
export function currencyFormatter(currency: number | undefined | null): string {
  return formatCurrencyValue(currency ?? 0);
}
